import { useQuery } from '@tanstack/react-query';

import { EMPTY_ARR } from '../../../../constants';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { DOCUMENTS_BASE_PATH } from '../../constants/documentsBasePath';
import { getDocument } from '../../requests/getDocument';

export const useDocument = (
  documentId: string,
  definitionName: string,
  includes?: string[],
  workflowName?: string,
  options?: { enabled?: boolean; queryKeySuffix?: unknown[] },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocument>>
  >({
    queryKey: [
      DOCUMENTS_BASE_PATH,
      documentId,
      definitionName,
      includes,
      workflowName,
      ...(options?.queryKeySuffix ?? EMPTY_ARR),
    ],
    queryFn: () =>
      getDocument(
        constructGet,
        documentId,
        definitionName,
        includes,
        workflowName,
      ),
    enabled: Boolean(documentId) && (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'document'),
    ...rest,
    meta: data?.meta,
  };
};
